import React, { useState, useEffect } from 'react';
import Base from '../base';
import { useParams } from 'react-router-dom';
import { Container } from '@themesberg/react-bootstrap';
import { isMobile, isBrowser } from 'react-device-detect';
import MobileCreateInspection from './mobileCreateIns';
import WebCreateInspection from './webCreateIns';
import { get } from '../../services/back.service';
import NotFoundInspect from '../error/notFoundInspect';

function CreateInspection() {
  const { editid } = useParams();
  const [id, setId] = useState(0)
  const [redirect, setRedirect] = useState(false)

  useEffect(() => {
    const validInspection = async () => {
      const respoInfo = await get(`/peritaje/validinspection/${(editid || 0)}`, {});
      if (respoInfo.success) {
        setId(respoInfo.data.id);
      } else {
        setRedirect(true);
      }
    };
    validInspection();
  }, [editid]);

  if (!redirect) {
    return (
      <Base>
        <Container style={{ padding: 5 }}>
          {isMobile && <MobileCreateInspection editid={id} />}
          {isBrowser && <WebCreateInspection editid={id} />}
        </Container>
      </Base>
    );
  } else {
    return <NotFoundInspect />;

  }
}

export default CreateInspection;
